import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs/Observable';
import { CaptainGig } from 'anchor-shared/lib/model/entity/captainGig';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class CaptainGigDAO extends BaseDAO<CaptainGig> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.CAPTAIN_GIG);
  }

  public adminCreateCaptainGig(
    captainId: number,
    charterId: number,
  ): Observable<CaptainGig> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/admin/create/${captainId}/charter/${charterId}`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const body = {
      captainId: captainId,
      charterId: charterId,
    };

    return this.apiHelper.apiCall<any>(url, method, null, body, headers);
  }

  public syncGigsForCharterEdit(
    charterId: number,
    vesselId: number,
  ): Observable<boolean> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/reset/${charterId}/${vesselId}`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<any>(url, method, null, null, headers);
  }
}
